const logs = {
	title: "Logger",
	id: "ID",
	user_id: "Bruker",
	action: "Hendelse",
	action_model: "Hendelsestype",
	action_id: "Hendelses ID",
	record: "Registrering",
	ip_address: "IP adresse",
	created_at: "Dato opprettet",
};
export default logs;